import React, { useState } from "react";
import "./SecurityOneQuickMenus.scss";
import SecurityOneScanFace from "./SecurityOneScanFace";
import { useNavigate } from "react-router-dom";

const SecurityOneQuickMenus = () => {
  const shortcuts = [
    { icon: "detection_and_zone", label: "Visitor" },
    { icon: "help", label: "Enquiry" },
    { icon: "how_to_reg", label: "Attendance " },
    { icon: "event_available", label: "Manage Leave" },
    { icon: "school", label: "Learnings" },
    { icon: "event", label: "Events" },
  ];

  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="security-one-quick-menus-container">
      <div className="security-one-home-shortcuts">
        {shortcuts.map((item, index) => (
          <div
            className="security-one-home-shortcuts-item"
            key={index}
            onClick={() => {
              // if (index === 0) setShowPopup(true); // Only open popup for "Face Scan"
              if (index === 0) navigate("/service-visitor");
              if (index === 2) navigate("/service-attendance");
            }}
          >
            <span className="material-symbols-outlined">{item.icon}</span>
            <span className="security-one-home-label">{item.label}</span>
          </div>
        ))}
      </div>

      {/* Pass showPopup and setShowPopup to the child component */}
      <SecurityOneScanFace showPopup={showPopup} setShowPopup={setShowPopup} />
    </div>
  );
};

export default SecurityOneQuickMenus;
